<template>
  <div class="animated fadeIn card view-wrapper" style="width: 100%; max-width: 1300px">
    <div class="card-body view">
      <div class="header">
        <div class="title">
          <!--          <font-awesome-icon icon="trophy" size="4x"></font-awesome-icon>-->
          <div>Best & Worst Testers</div>
        </div>
        <div class="steps">
          <el-steps :active="1" finish-status="success">
            <el-step title="Step 1"></el-step>
            <el-step title="Step 2"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="form-wrapper">
        <div class="d-flex flex-column justify-content-center w-100">
          <span class="subtitle" style="text-align: center">
            If you'd like to narrow your search, please select one or more criteria below:
          </span>
          <div class="form-group d-flex flex-wrap justify-content-center">
            <div v-for="item in dropdowns" :key="item.model">
              <el-select v-if="item.model === 'region'"
                         :model-value="localSearchFilters.essentials[item.model].value"
                         class="select-group-item"
                         @change="changeRegionData"
                         placeholder="Select region of the study" multiple filterable collapse-tags>
                <el-option-group label="Press Tab/Escape to exit">
                  <template v-for="value in (fields[item.fieldsName] || [])">
                    <el-option
                        v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value[0])"
                        :key="value[0]"
                        :label="value[0]"
                        :value="value[0]">
                      <span style="float: left">{{value[0]}}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{value[1]}}</span>
                    </el-option>
                  </template>
                  <template v-for="value in getAPACcounts()">
                    <el-option v-if="value[0] === 'APAC' && value[1]" :key="value[0]" :label="value[0]"
                               :value="value[0]">
                      <span style="float: left">{{value[0]}}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{value[1]}}</span>
                    </el-option>
                    <el-option v-else-if="value[1]" :key="value[0]" :label="value[0]"
                               :value="value[0]">
                      <span style="float: left; margin-left: 10px">{{value[0]}}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{value[1]}}</span>
                    </el-option>
                  </template>
                </el-option-group>
              </el-select>
              <el-select v-else
                         class="select-group-item"
                         v-model="localSearchFilters.essentials[item.model].value"
                         :placeholder="`Select ${item.model}`"
                         multiple filterable collapse-tags
                         @change="updateDropdownValues()"
              >
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option
                      v-for="option in fields[item.fieldsName]"
                      :key="option[0]" :label="option[0]" :value="option[0]">
                    <span style="float: left">{{option[0]}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{option[1]}}</span>
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
          <template v-if="yearsObject != null && localFormData.year.length === 2">
            <div class="row d-flex justify-content-center" style="align-items: center; margin-top: 20px">
              <div class="col-lg-4 col-md-4 input-wrapper">
                <div class="slider-wrapper">
                  <el-slider v-model="localFormData.year" range
                             :min="yearsObject['min']"
                             :max="yearsObject['max']"
                             :marks="yearsObject['marks']"
                             show-stops
                             @change="[parseYears(), updateDropdownValues()]"
                  >
                  </el-slider>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end">
          <router-link
              :to="{name: 'analytics', params: {startSearch: true, hideDescription: true, header: 'Confirm your selections:'}}"
              class="nav-link" style="padding: 0 !important;">
            <button class="btn next-button" @click="nextPage">Search</button>
          </router-link>
        </div>
        <div class="footnote">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchFunctions from '../../helpers/searchFunctions'
import _ from 'lodash'
import { mapActions } from 'vuex'
import studiesActions from '../../store/modules/studies/actionTypes'

export default {
  emits: ['update:formData', 'update:searchFilters', 'update-dropdown-values'],
  props: {
    'previousPage': Function,
    'nextPage': Function,
    'formData': Object,
    'searchFilters': Object,
    'fields': Object,
    'yearsObject': Object
  },
  name: 'TopWorstSecondForm',
  data () {
    return {
      localFormData: _.cloneDeep(this.formData),
      localSearchFilters: _.cloneDeep(this.searchFilters),
      dropdowns: [
        { model: 'client', fieldsName: 'Client' },
        { model: 'region', fieldsName: 'Region' },
        { model: 'businessUnit', fieldsName: 'Business Unit' },
        { model: 'category', fieldsName: 'Category' },
        { model: 'product', fieldsName: 'Product Type' }
      ],
      previousRegionValues: []
    }
  },
  methods: {
    ...mapActions({
      getUpdatedDropdownValues: studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS
    }),
    parseYears () {
      this.localSearchFilters.essentials.startYear.value = this.localFormData.year[0]
      this.localSearchFilters.essentials.endYear.value = this.localFormData.year[1]
    },
    getAPACcounts () {
      if (this.fields) {
        const tags = Object.entries(this.fields).find(el => el[0].toLowerCase() === 'region')
        if (tags) {
          const filteredValues = tags[1].filter(el => ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(el[0]))
          const counts = filteredValues.map(el => el[1])
          const count = counts.reduce((a, b) => {
            return a + b
          }, 0)
          const aspacObj = ['APAC', count]
          filteredValues.push(aspacObj)
          return filteredValues.sort((a, b) => {
            return a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0
          })
        }
      }
      return []
    },
    changeRegionData (data) {
      const mainRegion = 'APAC'
      const subRegions = ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia']
      if (data.includes(mainRegion)) {
        if (!this.previousRegionValues.includes(mainRegion)) {
          data = [...new Set([...data, ...subRegions])]
        } else {
          if (data.filter(el => el !== mainRegion).length < 3) {
            const index = data.indexOf(mainRegion)
            data.splice(index, 1)
          }
        }
      } else {
        if (this.previousRegionValues.includes(mainRegion)) {
          data = data.filter(x => !subRegions.includes(x))
        }
      }
      this.$set(this.localSearchFilters.essentials.region, 'value', data)
      this.previousRegionValues = data
      this.updateDropdownValues()
    },
    async updateDropdownValues () {
      if (this.localSearchFilters) {
        const data = searchFunctions.parseDataForSearch(_.cloneDeep(this.localSearchFilters))
        const parsedQuery = data.query
        const res = await this.getUpdatedDropdownValues({
          query: parsedQuery,
          queryMetrics: data.metrics,
          rdfType: this.localSearchFilters.metrics.useConcepts ? 'concepts' : 'fragrances',
          irtImplict: this.localSearchFilters.metrics.rdfType
        })
        this.$emit('update-dropdown-values', res.data.fields)
      }
    }
  },
  watch: {
    formData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localFormData)) {
          this.localFormData = _.cloneDeep(value)
        }
      }
    },
    localFormData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.formData)) {
          this.$emit('update:formData', _.cloneDeep(value))
        }
      }
    },
    searchFilters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localSearchFilters)) {
          this.localSearchFilters = _.cloneDeep(value)
        }
      }
    },
    localSearchFilters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.searchFilters)) {
          this.$emit('update:searchFilters', _.cloneDeep(value))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

hr.space {
  margin: 1.5em 0;
  visibility: hidden;
}

.view-wrapper {
  margin-bottom: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.93);
  border: 0;
}

.view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  box-shadow: 0 3px 6px #000000;
  padding: 0;

  .header {
    display: flex;
    justify-content: space-between;

    .steps {
      width: 270px;
      height: 62px;
      margin-top: 20px;
      margin-right: 29px;
    }
  }

  .form-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: $dusty-blue;

    .subtitle {
      @media screen and (min-width: $break-lg) {
        font-size: 25px;
        line-height: 45px;
      }
      @media screen and (min-width: $break-xl) {
        font-size: 30px;
        line-height: 50px;
      }
      @media screen and (min-width: $break-xxl) {
        font-size: 35px;
        line-height: 55px;
      }
      text-align: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 600;
      font-size: 35px;
      line-height: 55px;
      letter-spacing: 0;
      color: $dusty-blue;
    }

    .form-group {
      @media screen and (min-width: $break-lg) {
        padding: 0 12px;
        margin-top: 5px;
      }
      @media screen and (min-width: $break-xl) {
        padding: 0 32px;
        margin-top: 15px;
      }
      @media screen and (min-width: $break-xxl) {
        padding: 0 98px;
        margin-top: 35px;
      }
      text-align: center;
    }

    .select-group-item {
      @media screen and (min-width: $break-lg) {
        margin: 3px 3px;
        width: 45%;
      }
      @media screen and (min-width: $break-xl) {
        margin: 5px 5px;
        width: 35%;
      }
      @media screen and (min-width: $break-xxl) {
        margin: 5px 10px;
        width: 30%;
      }
    }

    .best-worst-switch {
      margin: 0 30px;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
    }

    .type-switch {
      margin: 0 15px;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
    }

    .number-input {
      margin-left: 20px;
      width: 98px !important;
      height: 55px !important;
    }
  }

  .next-button {
    width: 240px;
    height: 48px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    background: #300296;
    color: white;
    text-transform: uppercase;
    border-radius: 4px;
    margin-right: 40px;
    margin-bottom: 15px;
    @media screen and (min-width: $break-lg) {
      margin-right: 55px;
      margin-bottom: 20px;
    }
    @media screen and (min-width: $break-xl) {
      margin-right: 75px;
      margin-bottom: 25px;
    }
    @media screen and (min-width: $break-xxl) {
      margin-right: 100px;
      margin-bottom: 35px;
    }

    transition: background-color 0.2s linear;

    &:hover {
      background-color: #9256D9;
    }
  }

  .prev-button {
    width: 240px;
    height: 48px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    background: $pewter;
    color: white;
    text-transform: uppercase;
    border-radius: 4px;
    margin-left: 125px;
    margin-bottom: 55px;

    transition: background-color 0.2s linear;

    &:hover {
      background-color: $charcoal;
    }
  }
}

.title {
  margin-top: 20px;
  margin-left: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  color: $pewter;
  text-transform: uppercase;
  font-size: 30px;
  line-height: 24px;
  letter-spacing: 0.8px;
  @media screen and (min-width: $break-lg) {
    font-size: 35px;
    line-height: 26px;
    letter-spacing: 0.8px;
    margin-top: 23px;
    margin-left: 37px;
  }
  @media screen and (min-width: $break-xl) {
    font-size: 40px;
    line-height: 28px;
    letter-spacing: 0.9px;
    margin-top: 26px;
    margin-left: 42px;
  }
  @media screen and (min-width: $break-xxl) {
    font-size: 45px;
    line-height: 30px;
    letter-spacing: 0.9px;
    margin-top: 29px;
    margin-left: 47px;
  }
}

.footnote {
  height: 44px;
  background: transparent linear-gradient(268deg, #C961C5 0%, #DEBFDD 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  opacity: 0.9;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (min-width: $break-lg) {
    height: 49px;
    span {
      font-size: 18px;
      line-height: 20px;
      margin-right: 50px;
    }
  }
  @media screen and (min-width: $break-xl) {
    height: 54px;
    span {
      font-size: 18px;
      line-height: 22px;
      margin-right: 55px;
    }
  }
  @media screen and (min-width: $break-xxl) {
    height: 59px;
    span {
      font-size: 20px;
      line-height: 25px;
      margin-right: 60px;
    }
  }

  span {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 18px;
    color: $charcoal;
    margin-right: 45px;
  }
}

.title svg {
  margin-right: 0.5em;
}
</style>
<style lang="scss">
@import "../../assets/scss/variables";

.select-group-item {
  margin: 5px;
  width: 30%;

  .el-input__inner {
    font-family: 'Helvetica', sans-serif;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0;
    color: $default-focus;
    background-color: white !important;
    border: 2px solid #EBEDED !important;
    border-radius: 6px;
  }
}
</style>
